/**
 * The layout route element for the CRF screens — a `ToastProvider` around an
 * `Outlet`, and deliberately nothing else (the quotes/work precedent:
 * `routes.tsx` stays metadata so Fast Refresh cannot remount the provider and
 * drop a toast mid-message).
 *
 * ONE provider for all six screens: submitting a create navigates to the record,
 * saving a confirmation navigates back to the register — the toast that reports
 * each write must survive the navigation it causes.
 */

import { Outlet } from 'react-router-dom';
import { ToastProvider } from '../inquiries/toast';

export function CrfProviders(): React.JSX.Element {
  return (
    <ToastProvider>
      <Outlet />
    </ToastProvider>
  );
}
